/* eslint-disable react/no-multi-comp */
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormInitialValues } from 'redux-form';
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';
import find from 'lodash/find';
import moment from 'moment';

import { DURATION_REGEX } from 'constants';
import { FormError, Form } from 'components/forms/form-structure';
import { HiddenInput } from 'components/forms/form-elements';
import { SubmitButton } from 'components/widgets/buttons';
import { TimeReportDurationInput, TicketDescriptionInput, TimeReportDescriptionInput } from 'components/forms/help-text';
import Agreement from 'services/data/agreement';
import AgreementSelect from 'components/forms/selects/agreement-select';
import CompanySelect from 'components/forms/selects/company-select';
import requiredValidation from 'utils/required-validation';

import MetadataFormSection from './metadata-form-section';

class TicketlessTimeReportForm extends React.Component {
  static propTypes = {
    formValues: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    error: PropTypes.string,
    submitFailed: PropTypes.bool,
    change: PropTypes.func,
    submitting: PropTypes.bool,
    className: PropTypes.string,
    currentUser: PropTypes.object.isRequired,
    initialValues: PropTypes.object,
    companies: PropTypes.array
  };

  constructor() {
    super();
    this.state = {};
    this.x = 0;
    this.loadAgreement = this.loadAgreement.bind(this);
    this.setBillable = this.setBillable.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.formValues.agreement !== this.props.formValues.agreement) {
      this.loadAgreement(nextProps.formValues.agreement, nextProps);
    }
  }

  setBillable(agreement) {
    this.props.change('timeDefaultBillable', agreement && agreement.timeDefaultBillable);
  }

  loadAgreement(agreementId, props) {
    if (!agreementId) return;

    const { currentUser, formValues, initialize } = props;

    Agreement.findOne(agreementId, { load: 'rates' })
      .then((agreement) => {
        const defaultBillable = agreement.timeDefaultBillable;

        const initialValues = {
          ...formValues,
          agreement: agreementId,
          date: moment(),
          createdBy: currentUser.id,
          rate: defaultBillable ? find(agreement.rates, { role: currentUser.billingRole }).id : 0,
          afterHoursPremium: agreement.afterHoursPremium,
          loadedAgreement: agreement,
          timeDefaultBillable: agreement.timeDefaultBillable
        };

        initialize(initialValues);
      });
  }

  render() {
    const { handleSubmit, error, submitFailed, submitting, formValues, className, companies, initialValues = {} } = this.props;
    const { company, agreement, loadedAgreement } = formValues;

    const filteredCompanies = _.filter(companies, { companyType: 'Client' });

    return (
      <Form formRef={form => { this.formRef = form; }} onSubmit={handleSubmit} className={classNames(className, 'time-report-form')} customSubmitArea>
        <Field component={CompanySelect} options={filteredCompanies} name="company" label="Company" />
        { company &&
          <Field
            component={AgreementSelect}
            name="agreement"
            label="Agreement"
            company={company}
            onChangeFullValue={this.setBillable}
            searchParams={Agreement.activeQuery}
          />
        }
        { company && agreement && loadedAgreement &&
          <div>
            <MetadataFormSection {...this.props} agreement={loadedAgreement} hideAgreement initialValues={initialValues} />
            <Field component={TicketDescriptionInput} name="ticketDescription" label="Ticket description" />
            <Field component={HiddenInput} name="timeDefaultBillable" label="Time Reports are Billable by Default" />
            <Field component={TimeReportDescriptionInput} props={{ form: this.formRef }} name="timeReportDescription" label="Time report description" autoComplete="off" />
            <Field component={TimeReportDurationInput} name="timeReportDuration" label="Duration" />
            <div className="submit-area">
              <SubmitButton showLoading={submitting} />
              <FormError error={error} submitFailed={submitFailed} />
            </div>
          </div>
        }
      </Form>
    );
  }
}

const ConnectedComponent = connect((state, ownProps) => ({
  formValues: formValueSelector(ownProps.form)(state, 'company', 'agreement', 'loadedAgreement', 'ticketDescription', 'timeReportDescription', 'timeReportDuration', 'date', 'rate', 'afterHours'),
  companies: state.pageData.selectCompanies,
  currentUser: state.auth.currentUser,
  // Connect directly to the initial values in the store, otherwise redux just passes through the first initial
  // values which was passed to this component, and we don't see updates to this object in our render function
  initialValues: getFormInitialValues(ownProps.form)(state)
}))(TicketlessTimeReportForm);

export default reduxForm({
  validate: (values) => {
    const errors = requiredValidation(['company', 'agreement', 'ticketDescription', 'timeReportDescription', 'timeReportDuration'], values);
    if (Number(values.timeReportDuration) === 0) errors.timeReportDuration = 'Required';
    if (Number(values.timeReportDuration) > 24) errors.timeReportDuration = 'Create multiple time reports if you really worked more than 24 hrs';
    if (!DURATION_REGEX.test(values.timeReportDuration)) errors.timeReportDuration = 'Must be a multiple of 0.25';
    return errors;
  }
})(ConnectedComponent);
